import { render, staticRenderFns } from "./uncleCakeOrderDetail.vue?vue&type=template&id=24150d16&scoped=true&"
import script from "./uncleCakeOrderDetail.vue?vue&type=script&lang=js&"
export * from "./uncleCakeOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./uncleCakeOrderDetail.vue?vue&type=style&index=0&id=24150d16&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24150d16",
  null
  
)

export default component.exports